import { render, staticRenderFns } from "./type-of-graphs.vue?vue&type=template&id=02a19482&scoped=true"
import script from "./type-of-graphs.vue?vue&type=script&lang=js"
export * from "./type-of-graphs.vue?vue&type=script&lang=js"
import style0 from "./type-of-graphs.vue?vue&type=style&index=0&id=02a19482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a19482",
  null
  
)

export default component.exports